import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import { MyStore } from 'kts-platform-frame/redux';
import ModulesAction from './Modules.Action';
const demoImg = require('./imgs/demo.png');
import {
    Upload,
    Icon,
    message,
    Progress,
    Modal
} from 'antd';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    type: number;
    onChange?: (value: any) => void;
    value?: any;
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))

export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
        ModulesAction.changeSnapImg(this.props.value);
        ModulesAction.changeModalImgsIs(1);
        this.props.onChange(undefined);
    }
    
    componentWillMount () {
        ModulesAction.uploadToken(this);
    }

    render() {
        const token = this.modulesState.uploadTokenData && this.modulesState.uploadTokenData.token;
        const uploadUrl = this.modulesState.uploadTokenData && this.modulesState.uploadTokenData.uploadUrl;
        const key = this.modulesState.uploadTokenData && this.modulesState.uploadTokenData.keyPrefix;
        const watchVisible = this.modulesState.watchVisible;
        const snapImg = this.modulesState.snapImg;
        const { user } = MyStore.instance.getState(); 
        return (
            <div className={css['credentials']}>
                {
                    (snapImg === '' || snapImg ===undefined || snapImg === null) ? 
                    <Upload
                        className={css['credentials-upload-first']}
                        beforeUpload={this.beforeUpload}
                        headers={{Authorization: user.cToken}}
                        data={{key, token}}
                        action={`//${uploadUrl}`}
                        multiple={false}
                        showUploadList={true}
                        onChange={this.onChange}
                        listType='picture'
                    >
                        <div className={css['credentials-default']}>
                            <Icon type="plus" />
                            <span>点击上传</span>
                        </div>
                    </Upload>
                    :
                    <div className={css['credentials-demo']}>
                        <img src={snapImg}/>
                        <div className={`${css['credentials-demo-mask']} ${css['credentials-demo-success']}`}>
                            <Icon 
                                type="search"
                                onClick={() => {
                                    this.changeWatchVisible(true);
                                    ModulesAction.changeModalImgsIs(1);
                                }}
                            />
                            <Upload
                                beforeUpload={this.beforeUpload}
                                data={{key, token}}
                                action={`//${uploadUrl}`}
                                headers={{Authorization: user.cToken}}
                                multiple={false}
                                showUploadList={true}
                                onChange={this.onChange}
                                listType='picture'
                            >
                                <Icon
                                    type="bianji1"
                                />
                            </Upload>
                        </div>
                    </div>
                }
                {
                    !this.props.type && <div className={css['credentials-demo']}>
                        <img src={demoImg}/>
                        <div className={css['credentials-demo-mask']}>
                            <Icon 
                                type="search"
                                onClick={() => {
                                    this.viewDemo();
                                }}
                            />
                            <span className={css['credentials-demo-mask-title']}>示例</span>
                        </div>
                    </div>
                }
                <Modal
                    visible={watchVisible}
                    footer={null}
                    className={css['credentials-watch']}
                    onCancel={() => {
                        this.changeWatchVisible(false);
                    }}
                >
                    {
                        this.modulesState.modalImgIs === 0 ?
                        <img alt="示例" src={require('./imgs/demo.png')} style={{ width: '100%' }} />
                        : <img alt="示例" src={snapImg} style={{ width: '100%' }} />
                    }
                </Modal>
            </div>
        );
    }

    private beforeUpload = (file) => {
        const isJPG = (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/bmp' || file.type === 'image/png');
        if (!isJPG) {
            message.error('只支持jpg、jpeg、bmp、png格式!');
        }
        const isLt2M = file.size / 1024 / 1024 < 5;
        if (!isLt2M) {
            message.error('图片大小不能超过5M!');
        }
        if (isJPG && isLt2M) {
            this.percentSelfAdd();
        }
        return isJPG && isLt2M;
    }

    private onChange = (info) => {  
        const {thumbUrl, response} = info.file;
        if (thumbUrl && response && response.body && response.body.key) {
            ModulesAction.changeSnapImg(thumbUrl);
            ModulesAction.changeModalImgsIs(1);
            this.props.onChange(response.body.key);
        }
    }

    private percentSelfAdd = () => {
    }

    private changeWatchVisible = b => {
        ModulesAction.changeWatchVisible(b);
    }

    private viewDemo = () => {
        this.changeWatchVisible(true);
        ModulesAction.changeModalImgsIs(0);
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/CompanyInfo/Qualification/UI.Credentials.tsx